import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { provideStates } from '@ngxs/store';

import { NewsComplaintState } from './news-complaint.state';
import { NewsComplaintStateService } from './news-complaint-state.service';

export function provideNewsComplaints(): (Provider | EnvironmentProviders)[] {
  return [
    provideStates([NewsComplaintState]),
    provideAppInitializer(() => {
      const service = inject(NewsComplaintStateService);
      service.init();
    }),
  ];
}
